<div class="inner-page-section">
    <div class="sub-section-header">
        <h1 class="title">Automated Mapping Behavior</h1>
        <span class="actions">
            Last Updated: <span *ngIf="lastUpdated; else never">{{ lastUpdated | date: 'M/d/yy, h:mm a' }}</span>
            <ng-template #never>Never</ng-template>
        </span>
    </div>

    <mat-card appearance="outlined" style="margin-bottom: 25px;">
        <mat-card-content style="display: flex; flex-direction: column; gap: 16px;">
            <div style="margin-bottom: 8px;">Configure whether mapping happens when documents arrive before requirements, requirements arrive before documents, or both.</div>

            <div *ngFor="let item of toggleSettings" style="display: flex; flex-direction: column; gap: 8px;">
                <mat-slide-toggle [checked]="item.currentValue" (change)="onToggleFeature(item, $event.checked)">
                    {{ item.title }}
                </mat-slide-toggle>
                <span>{{ item.description }}</span>
            </div>
        </mat-card-content>
    </mat-card>

    <h1 class="title">Attachment Exclusion Tags</h1>
    <mat-card appearance="outlined" style="margin-bottom: 25px;">
        <mat-card-header>Attachments with the following tags will never be linked to requirements.</mat-card-header>

        <mat-card-content *ngIf="!accountSettingsLoaded">
            <mat-spinner mode="indeterminate" diameter="30"></mat-spinner>
        </mat-card-content>

        <mat-card-content *ngIf="accountSettingsLoaded">
            <object-tags [tags]="attachmentTags" [account]="account" (tagsChange)="saveRequirementTags($event)"></object-tags>
        </mat-card-content>
    </mat-card>

    <mat-card appearance="outlined">
        <mat-card-header>The following tags will not create an orphaned document requirement if their associated requirement does not yet exist</mat-card-header>

        <mat-card-content *ngIf="!accountSettingsLoaded">
            <mat-spinner mode="indeterminate" diameter="30"></mat-spinner>
        </mat-card-content>

        <mat-card-content *ngIf="accountSettingsLoaded">
            <object-tags [tags]="orphanAttachmentTags" [account]="account" (tagsChange)="saveOrphanTags($event)"></object-tags>
        </mat-card-content>
    </mat-card>

    <mat-card-content *ngIf="errorMessage">
        {{ errorMessage }}
    </mat-card-content>
</div>
